import React from 'react';
import Typography from '@mui/material/Typography';

interface StepCounterProps {
  currentStep: number;
  totalSteps: number;
}

export const StepCounter: React.FC<StepCounterProps> = ({ currentStep, totalSteps }) => {
  if (totalSteps <= 1) return null;

  return (
    <Typography variant="body2" color="textSecondary" className="mb-4">
      Step {currentStep} of {totalSteps}
    </Typography>
  );
};
